export default {
  namespaced: true,
  distribution_list: {
    title: "lista de distribución",
    sidebar: {
      list_name: 'nombre',
      users: 'usuarios',
      email: 'correos',
    },
    table_distribution: {
      title: "lista",
      name: "nombre",
      emails: "correos",
      noemails: "sin correos electrónicos",
      successful_creation: "Lista de distribución creada correctamente",
      error_creation: "Error al crear la lista de distribución",
      successful_edit: "Lista de distribución editada correctamente",
      error_edit: "Error al editar la lista de distribución",
      successful_delete: 'Lista de distribución eliminada correctamente',
      error_delete: 'Error al eliminar la lista de distribución',
      users_count: 'número de usuarios',
      emails_count: 'número de correos',
    }
  }
};
